import * as layout from '../../components/markLayout.module.css';
import React from 'react';
import { useParams, Link } from 'react-router-dom';
import Section from '@hero/ui-kit/layout/Section';
import H from '@hero/ui-kit/typography/H';
import P from '@hero/ui-kit/typography/P';
import InlineLoader from '../../../../components/InlineLoader';
import QueryInlineError from '../../../../components/QueryInlineError';
import useSegment from '../../api/useSegment';
import SegmentBuilder from './SegmentBuilder';
const EditSegment: React.FC = () => {
    const { segmentId } = useParams<{
        segmentId: string;
    }>();
    const numericId = Number(segmentId);
    const { data: segmentResponse, isLoading, error } = useSegment(numericId);
    const segment = segmentResponse?.data;
    if (isLoading) return <InlineLoader />;
    // A failed background refetch keeps cached data; unmounting would drop the draft.
    if (error && !segment) return <QueryInlineError error={error} />;
    if (!segment) return <P>Segment not found.</P>;
    return (
        <Section
            subtheme={['regular', 'background']}
            paddingVertical="small"
            paddingHorizontal="regular"
        >
            <H role="h5">{`Edit: ${segment.name}`}</H>
            {segment.kind === 'IMPORTED' ? (
                <div
                    style={{
                        backgroundColor: 'var(--mark-warning-surface)',
                        marginTop: '1rem'
                    }}
                    className={layout.panel}
                >
                    <P noDefaultMargin>
                        Imported segments cannot be edited.{' '}
                        <Link to={`/mark/segments/import?segment_id=${numericId}`}>
                            Replace via CSV
                        </Link>{' '}
                        to update.
                    </P>
                </div>
            ) : (
                <SegmentBuilder
                    mode="edit"
                    segmentId={numericId}
                    initialValues={{
                        name: segment.name,
                        targetKind: segment.target_kind,
                        match: segment.match,
                        filters: segment.filters,
                        sourceSegmentId: segment.source_segment_id
                    }}
                    usedBy={segment.used_by}
                />
            )}
        </Section>
    );
};
export default EditSegment;
